'use strict';

var Util = require('./index');

module.exports = {
    PerformanceObserver: function PerformanceObserver() {
        if (window.PerformanceObserver) {
            try {
                var chromeVersionReg = /Chrome\/(\d+)/;
                var UA = Util.getUserAgent();
                if (chromeVersionReg.test(UA)) {
                    var version = UA.match(chromeVersionReg)[1];
                    if (parseInt(version) > 59) return true;
                } else {
                    return true;
                }
            } catch (e) {}
        }
    },
    MutationObserver: function MutationObserver() {
        if (window.MutationObserver) {
            try {
                // 处理IE11下开启首屏后的模板渲染异常问题
                var IEVersion = -1;
                var UA = Util.getUserAgent();
                if (UA.indexOf('compatible') > -1 && UA.indexOf('MSIE') > -1) {
                    new RegExp('MSIE (\\d+\\.\\d+);').test(UA);
                    IEVersion = parseFloat(RegExp['$1']);
                } else if (UA.indexOf('Trident') > -1 && UA.indexOf('rv:11.0') > -1) {
                    IEVersion = 11;
                }

                if (IEVersion === -1 || IEVersion > 11) return true;
            } catch (e) {}
        }
    },
    PerformanceNow: function PerformanceNow() {
        return window.performance && window.performance.now && typeof window.performance.now === 'function' ? true : false;
    },
    GetEntries: function GetEntries() {
        return window.performance && typeof window.performance.getEntries === 'function' ? true : false;
    }
};